// extracted by mini-css-extract-plugin
export default {"container":"page-spinner_container__qHUvs"};